export const environment = {
  production: false,
  apiUrl: 'https://qa-dullgrading.bakerhughes.com/dd-api/',
  geminiUrl: 'https://qa-gemini.azure.bakerhughes.com/',
  oktaIssuer: 'https://bh.oktapreview.com/oauth2/aus1u6bpaprtCz9Tq0h8',
  oktaClientId: '0oa1u2zxe6y1IAyad0h8',
  appUrl: 'https://qa-dullgrading.bakerhughes.com',
  dataVisualization: 'https://qa-gemini.azure.bakerhughes.com/data-visualization/',
  msalConfig: {
    auth: {
      clientId: "4050032a-bb1b-45d6-a541-d91c07b0bf91",
      authority: "https://login.microsoftonline.com/d584a4b7-b1f2-4714-a578-fd4d43c146a6/v2.0",
      redirectUri: "https://qa-dullgrading.bakerhughes.com",
      postLogoutRedirectUri: "https://qa-dullgrading.bakerhughes.com",
    },
    loginScope: ['email', 'openid', 'profile', 'user.read'],
    authScope: ['4050032a-bb1b-45d6-a541-d91c07b0bf91/.default'],
  }
};
